import * as React from 'react';
import * as styles from './styles.css';
export function Title(_ref) {
  var title = _ref.title;
  return React.createElement("div", {
    className: styles['title']
  }, title);
}